module.exports = __webpack_public_path__ + "assets/img/about.190f91f5.png";